import { useMutation } from '@tanstack/react-query'

import { PostArquivosDownloadMultiplosService } from '../http/post-arquivos-download-multiplos.service'

export const useArquivosDownloadMultiplos = () => {
  return useMutation({
    mutationFn: (urls: string[]) => new PostArquivosDownloadMultiplosService().execute(urls),
    onSuccess: (response) => {
      const blob = new Blob([response.data], { type: 'application/zip' })
      const downloadUrl = globalThis.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = downloadUrl
      link.download = `arquivos_${Date.now()}.zip`
      document.body.appendChild(link)
      link.click()
      link.remove()
      globalThis.URL.revokeObjectURL(downloadUrl)
    },
  })
}
